import { VacanciesI } from '../interfaces/vacancies.interface'
import { VacanciesService } from '../services/vacancies.service'

// services
const vacanciesService = new VacanciesService()

import {
    VacanciesGetListResponseT,
    VacanciesGetFeedBacksListResponseT,
    VacanciesGetCategoriesListResponseT,
    VacanciesGetRegionsListResponseT,
    VacanciesGetExperienceListResponseT,
    VacanciesCreateExperiencePayloadT,
    VacanciesCreateExperienceResponseT,
    VacanciesCreateRegionPayloadT,
    VacanciesCreateRegionResponseT,
    VacanciesUpdateExperienceResponseT,
    VacanciesCreateCategoryPayloadT,
    VacanciesCreateCategoryResponseT,
    VacanciesUpdateRegionResponseT,
    VacanciesUpdateCategoryResponseT,
    VacanciesCreateVacancyPayloadT,
    VacanciesUpdateVacancyResponseT,
    VacanciesCreateVacancyResponseT,
    VacanciesGetVacancyResponseT,
    VacanciesUpdateVacancyStatusResponseT,
    VacanciesGetVacancyStatusesResponseT,
} from '@/core/types/vacancies.types'

class Vacancies implements VacanciesI {
    getList(page: number): Promise<VacanciesGetListResponseT> {
        return vacanciesService.getList(page)
    }

    getVacancyStatuses(): Promise<VacanciesGetVacancyStatusesResponseT> {
        return vacanciesService.getVacancyStatuses()
    }

    getVacancy(vacancy_id: number): Promise<VacanciesGetVacancyResponseT> {
        return vacanciesService.getVacancy(vacancy_id)
    }

    getFeedBacksList(page: number): Promise<VacanciesGetFeedBacksListResponseT> {
        return vacanciesService.getFeedBacksList(page)
    }

    getCategoriesList(page: number): Promise<VacanciesGetCategoriesListResponseT> {
        return vacanciesService.getCategoriesList(page)
    }

    getRegionsList(page: number): Promise<VacanciesGetRegionsListResponseT> {
        return vacanciesService.getRegionsList(page)
    }

    getExperienceList(page: number): Promise<VacanciesGetExperienceListResponseT> {
        return vacanciesService.getExperienceList(page)
    }

    createExperience(
        experience_payload: VacanciesCreateExperiencePayloadT
    ): Promise<VacanciesCreateExperienceResponseT> {
        return vacanciesService.createExperience(experience_payload)
    }

    createRegion(
        region_payload: VacanciesCreateRegionPayloadT
    ): Promise<VacanciesCreateRegionResponseT> {
        return vacanciesService.createRegion(region_payload)
    }

    createCategory(
        category_payload: VacanciesCreateCategoryPayloadT
    ): Promise<VacanciesCreateCategoryResponseT> {
        return vacanciesService.createCategory(category_payload)
    }

    createVacancy(
        vacancy_payload: VacanciesCreateVacancyPayloadT
    ): Promise<VacanciesCreateVacancyResponseT> {
        return vacanciesService.createVacancy(vacancy_payload)
    }

    publishVacancy(vacancy_id: number): Promise<void> {
        return vacanciesService.publishVacancy(vacancy_id)
    }

    archiveVacancy(vacancy_id: number): Promise<void> {
        return vacanciesService.archiveVacancy(vacancy_id)
    }

    updateExperience(
        experience_id: number,
        experience_payload: VacanciesCreateExperiencePayloadT
    ): Promise<VacanciesUpdateExperienceResponseT> {
        return vacanciesService.updateExperience(experience_id, experience_payload)
    }

    updateRegion(
        region_id: number,
        region_payload: VacanciesCreateRegionPayloadT
    ): Promise<VacanciesUpdateRegionResponseT> {
        return vacanciesService.updateRegion(region_id, region_payload)
    }

    updateCategory(
        category_id: number,
        category_payload: VacanciesCreateCategoryPayloadT
    ): Promise<VacanciesUpdateCategoryResponseT> {
        return vacanciesService.updateCategory(category_id, category_payload)
    }

    updateVacancy(
        vacancy_id: number,
        vacancy_payload: VacanciesCreateVacancyPayloadT
    ): Promise<VacanciesUpdateVacancyResponseT> {
        return vacanciesService.updateVacancy(vacancy_id, vacancy_payload)
    }

    updateVacancyStatus(
        vacancy_id: number,
        status_id: number
    ): Promise<VacanciesUpdateVacancyStatusResponseT> {
        return vacanciesService.updateVacancyStatus(vacancy_id, status_id)
    }

    archiveFeedback(feedback_id: number): Promise<void> {
        return vacanciesService.archiveFeedback(feedback_id)
    }

    unarchiveFeedback(feedback_id: number): Promise<void> {
        return vacanciesService.unarchiveFeedback(feedback_id)
    }

    setFeedbackStatus(feedback_id: number, status_id: number): Promise<void> {
        return vacanciesService.setFeedbackStatus(feedback_id, status_id)
    }

    deleteExperience(experience_id: number): Promise<void> {
        return vacanciesService.deleteExperience(experience_id)
    }

    deleteRegion(region_id: number): Promise<void> {
        return vacanciesService.deleteRegion(region_id)
    }

    deleteCategory(category_id: number): Promise<void> {
        return vacanciesService.deleteCategory(category_id)
    }

    deleteVacancy(vacancy_id: number): Promise<void> {
        return vacanciesService.deleteVacancy(vacancy_id)
    }
}

export const vacancies = new Vacancies()
